define('views/content/country_distributors',['require','views/base/list_page_view','views/components/country_distributor/country_distributors','collections/country_distributors','text!templates/content/country_distributors.html'],function(require){

    var BaseListPageView = require('views/base/list_page_view');

    var CDsView = require('views/components/country_distributor/country_distributors');
    var CDsCollection = require('collections/country_distributors');

    var temp = require("text!templates/content/country_distributors.html");

    return BaseListPageView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'country_distributor-page',
        titleKey: 'country_distributors',

        setCollection: function () {
            this.collection = new CDsCollection();
        },

        onRender: function() {
            this.ListContainer.show(new CDsView({
                collection: this.collection
            }));
        }

    });
});
